import React from "react";
import "./Aerra.scss";
import data from "./data.json";
import Card from "../../../Component/Card/card";
import Aerra8images from "../../../Media/BSD/Eonna/Aerra8";
import Aerra9images from "../../../Media/BSD/Eonna/Aerra9";
import Aerra10images from "../../../Media/BSD/Eonna/Aerra10";

const imageMap = {
  Aerra8images,
  Aerra9images,
  Aerra10images,
  // Add other image arrays here if you have more sets
};

const produk = () => {
  return (
    <div id="Aerra" className="produk">
      <h1>Welcome to Aerra</h1>
      <h2>Cicilan Start 22 Juta/Bulan</h2>
      <div className="cardhome-containerf">
        {data.cards.map((card, index) => {
          // Determine the logo dynamically
          // Determine the logo dynamically
          return (
            <Card
              key={index}
              carousel={imageMap[card.imagesKey]}
              title={card.title}
              subtitle={card.subtitle}
              price={card.price}
              subprice={card.subprice}
              details={card.details}
              whatsappLink={card.whatsappLink} // Pass the WhatsApp link
            />
          );
        })}
      </div>
    </div>
  );
};

export default produk;
